import {
  CheckMetadata,
  createSimpleCheckMetadataArray,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import RiskLevelSticker from 'dashboard/components/RiskLevelSticker';
import { IdAgeInconsistencyDetection } from 'dashboard/models/check';
import { RiskData, RiskLevel } from 'dashboard/models/verification-check';

export const computeIdAgeInconsistencyDetectionMetadata = (
  check: IdAgeInconsistencyDetection,
): CheckMetadata => {
  const metadata = [];

  const age = check.metadata?.age;
  metadata.push({
    label: 'Expected Portrait Age',
    value: age ? Math.trunc(age) + ' years old' : '-',
  });

  const risks = check?.metadata?.risks;
  const ageInconsistencyRiskData = risks?.find(
    (r: RiskData) => (r.reason as string) === 'inconsistent_age',
  );

  if (ageInconsistencyRiskData) {
    metadata.push({
      label: 'Age Comparison Risk',
      value: RiskLevelSticker({ riskLevel: ageInconsistencyRiskData['level'] as RiskLevel }),
    });
  }

  return {
    metadata: createSimpleCheckMetadataArray(metadata),
    hideIfVerificationPassed: false,
  };
};
